export const SPONTANEOUS = { id: 'spontaneous', label: 'Vaginale non operativo/spontaneo' };
export const FORCEPS = { id: 'forceps', label: 'Vaginale con uso forcipe' };
export const SUCTION_CUP = { id: 'suction_cup', label: 'Vaginale con uso ventosa' };
export const CESAREAN = { id: 'cesarean', label: 'Taglio cesareo' };
